import { render } from "./PaymentFailure.vue?vue&type=template&id=4756f0b2&scoped=true"
import script from "./PaymentFailure.vue?vue&type=script&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&lang=js"

import "./PaymentFailure.vue?vue&type=style&index=0&id=4756f0b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4756f0b2"]])

export default __exports__